// import Box from "@mui/material/Box";
// import Navbar from "../components/Navbar";
// import AboutUs from "../components/AboutUs";
// import Specalization from "../components/Specialization";
// import Services from "../components/Services";
// import Footer from "../pages/main/footer";
// import Portfolio from "../components/Portfolio";
// import OurClient from "../components/OurClient";
// import React, { useState, useEffect } from "react";
// import api from "../services/httpService";

// const isVideo = (url) => {
//   if (!url) return false;
//   const videoExtensions = ["mp4", "webm", "ogg", "mov", "avi"];
//   const ext = url.split(".").pop().split("?")[0].toLowerCase();
//   return videoExtensions.includes(ext);
// };

// const isImage = (url) => {
//   if (!url) return false;
//   const imageExtensions = ["jpg", "jpeg", "png", "webp", "gif", "svg"];
//   const ext = url.split(".").pop().split("?")[0].toLowerCase();
//   return imageExtensions.includes(ext);
// };

// const HomePage = () => {
//   const [mediaUrl, setMediaUrl] = useState("");
//   const [title, setTitle] = useState("");
//   const [description, setDescription] = useState("");
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     fetchHero();
//   }, []);

//   const fetchHero = async () => {
//     try {
//       const res = await api.get("/sentinix/homesettings");
//       const data = Array.isArray(res.data.data)
//         ? res.data.data
//         : [res.data.data];

//       const hero1 = data.find((s) => s.sectionType === "hero1");

//       if (hero1) {
//         setMediaUrl(hero1.imageKey || "");
//         setTitle(hero1.title || "");
//         setDescription(hero1.description || "");
//       }
//     } catch (err) {
//       console.error("Failed to fetch hero section:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <Navbar />

//       {/* ===== Hero Section ===== */}
//       <Box
//         sx={{
//           position: "relative",
//           width: "100%",
//           height: { xs: "40vh", sm: "60vh", md: "100vh" },
//           overflow: "hidden",
//           margin: 0,
//           padding: 0,
//           backgroundColor: "#000",
//         }}
//       >
       
//         {!loading && isVideo(mediaUrl) && (
//           <video
//             autoPlay
//             loop
//             muted
//             style={{
//               width: "100%",
//               height: "100%",
//               objectFit: "cover",
//               display: "block",
//             }}
//           >
//             <source src={mediaUrl} type="video/mp4" />
//             Your browser does not support the video tag.
//           </video>
//         )}

//         {!loading && isImage(mediaUrl) && (
//           <Box
//             component="img"
//             src={mediaUrl}
//             alt="Hero"
//             sx={{
//               width: "100%",
//               height: "100%",
//               objectFit: "cover",
//               display: "block",
//             }}
//           />
//         )}

//         {/* {!loading && (title || description) && (
//           <Box
//             sx={{
//               position: "absolute",
//               top: 0,
//               left: 0,
//               width: "100%",
//               height: "100%",
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               justifyContent: "center",
//               background: "rgba(0,0,0,0.4)",
//               color: "#fff",
//               textAlign: "center",
//               px: { xs: 2, md: 6 },
//             }}
//           >
//             {title && (
//               <Box
//                 component="h1"
//                 sx={{
//                   fontSize: { xs: "1.5rem", sm: "2rem", md: "3rem" },
//                   fontWeight: "bold",
//                   mb: 2,
//                   color: "#fff",
//                   margin: 0,
//                 }}
//               >
//                 {title}
//               </Box>
//             )}
//             {description && (
//               <Box
//                 component="p"
//                 sx={{
//                   fontSize: { xs: "0.9rem", sm: "1rem", md: "1.3rem" },
//                   maxWidth: "700px",
//                   color: "#f0f0f0",
//                   mt: 2,
//                 }}
//               >
//                 {description}
//               </Box>
//             )}
//           </Box>
//         )} */}
//       </Box>

//       <AboutUs />
//       <Specalization />
//       <Services />
//       <Portfolio />
//       <OurClient />
//       <Footer />
//     </>
//   );
// };

// export default HomePage;

// import Box from "@mui/material/Box";
// import Navbar from "../components/Navbar";
// import AboutUs from "../components/AboutUs";
// import Specalization from "../components/Specialization";
// import Services from "../components/Services";
// import Footer from "../pages/main/footer";
// import Portfolio from "../components/Portfolio";
// import OurClient from "../components/OurClient";
// import React, { useState, useEffect } from "react";
// import api from "../services/httpService";

// const isVideo = (url) => {
//   if (!url) return false;
//   const videoExtensions = ["mp4", "webm", "ogg", "mov", "avi"];
//   const ext = url.split(".").pop().split("?")[0].toLowerCase();
//   return videoExtensions.includes(ext);
// };

// const isImage = (url) => {
//   if (!url) return false;
//   const imageExtensions = ["jpg", "jpeg", "png", "webp", "gif", "svg"];
//   const ext = url.split(".").pop().split("?")[0].toLowerCase();
//   return imageExtensions.includes(ext);
// };

// const HomePage = () => {
//   const [mediaUrl, setMediaUrl] = useState("");
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     fetchHero();
//   }, []);

//   const fetchHero = async () => {
//     try {
//       const res = await api.get("/sentinix/homesettings");
//       const data = Array.isArray(res.data.data)
//         ? res.data.data
//         : [res.data.data];

//       const hero1 = data.find((s) => s.sectionType === "hero1");

//       if (hero1) {
//         setMediaUrl(hero1.imageKey || "");
//       }
//     } catch (err) {
//       console.error("Failed to fetch hero section:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <Navbar />

//       {/* ===== Hero Section ===== */}
//       <Box
//         sx={{
//           position: "relative",
//           width: "100%",
//           height: { xs: "40vh", sm: "60vh", md: "100vh" },
//           overflow: "hidden",
//           margin: 0,
//           padding: 0,
//           backgroundColor: "#000",
//         }}
//       >
//         {!loading && isVideo(mediaUrl) && (
//           <video
//             autoPlay
//             loop
//             muted
//             style={{
//               width: "100%",
//               height: "100%",
//               objectFit: "cover",
//               display: "block",
//             }}
//           >
//             <source src={mediaUrl} type="video/mp4" />
//           </video>
//         )}

//         {!loading && isImage(mediaUrl) && (
//           <Box
//             component="img"
//             src={mediaUrl}
//             alt="Hero"
//             sx={{
//               width: "100%",
//               height: "100%",
//               objectFit: "cover",
//               display: "block",
//             }}
//           />
//         )}
//       </Box>

//       <AboutUs />
//       <Specalization />
//       <Services />
//       <Portfolio />
//       <OurClient />
//       <Footer />
//     </>
//   );
// };

// export default HomePage;

import Box from "@mui/material/Box";
import Navbar from "../components/Navbar";
import AboutUs from "../components/AboutUs";
import Specalization from "../components/Specialization";
import Services from "../components/Services";
import Footer from "../pages/main/footer";
import Portfolio from "../components/Portfolio";
import OurClient from "../components/OurClient";
import React, { useState, useEffect } from "react";
import api from "../services/httpService";

const isVideo = (url) => {
  if (!url) return false;
  const videoExtensions = ["mp4", "webm", "ogg", "mov", "avi"];
  const ext = url.split(".").pop().split("?")[0].toLowerCase();
  return videoExtensions.includes(ext);
};

const isImage = (url) => {
  if (!url) return false;
  const imageExtensions = ["jpg", "jpeg", "png", "webp", "gif", "svg"];
  const ext = url.split(".").pop().split("?")[0].toLowerCase();
  return imageExtensions.includes(ext);
};

const HomePage = () => {
  const [mediaUrl, setMediaUrl] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchHero();
  }, []);

  const fetchHero = async () => {
    try {
      const res = await api.get("/sentinix/homesettings");
      const data = Array.isArray(res.data.data)
        ? res.data.data
        : [res.data.data];

      const hero1 = data.find((s) => s.sectionType === "hero1");

      if (hero1) {
        setMediaUrl(hero1.imageKey || "");
      }
    } catch (err) {
      console.error("Failed to fetch hero section:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />

      {/* ===== Hero Section ===== */}
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: !loading && isVideo(mediaUrl)
            ? { xs: "40vh", sm: "60vh", md: "100vh" }
            : "auto",
          overflow: "hidden",
          margin: 0,
          padding: 0,
          backgroundColor: "#000",
          lineHeight: 0,
        }}
      >
        {/* ✅ VIDEO — fixed height, cover fill */}
        {!loading && isVideo(mediaUrl) && (
          <video
            autoPlay
            loop
            muted
            playsInline
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          >
            <source src={mediaUrl} type="video/mp4" />
          </video>
        )}

        {/* ✅ IMAGE — width 100%, height auto = FULL image always visible */}
        {!loading && isImage(mediaUrl) && (
          <Box
            component="img"
            src={mediaUrl}
            alt="Hero"
            sx={{
              width: "100%",
              height: "auto",      
              display: "block",
              maxHeight: "100vh",  
            }}
          />
        )}
      </Box>

      <AboutUs />
      <Specalization />
      <Services />
      <Portfolio />
      <OurClient />
      <Footer />
    </>
  );
};

export default HomePage;